export default __webpack_public_path__ + "static/media/HerHackathon.89bbe187.png";